import { useMutation } from "@tanstack/react-query";
import { abortableDelay } from "../helpers.js";
import { useAxiosProvider } from "../providers/axios-provider.js";
import "react/jsx-runtime";
import "react";
import "axios";
const cancelInvoice = (axios) => async (clinicReferenceId, invoiceReferenceId, reason, abortController) => {
  const { data } = await axios.put(
    `/api/v1/internal/invoices/clinics/${clinicReferenceId}/invoices/${invoiceReferenceId}/cancel`,
    {
      reason
    },
    { signal: abortController.signal }
  );
  return data;
};
const useInvoiceCancellation = ({ onSuccess, onMutate, onUndo, onError } = {}) => {
  const { invoice } = useAxiosProvider();
  if (!invoice) {
    throw new Error("invoice axios instance is not initialized");
  }
  const mutation = useMutation({
    mutationFn: async ({ clinicReferenceId, invoiceReferenceId, reason }) => {
      const abortController = new AbortController();
      onUndo == null ? void 0 : onUndo(() => {
        abortController.abort();
      });
      await abortableDelay(4e3, abortController.signal);
      if (abortController.signal.aborted) {
        return { canceled: true };
      }
      return cancelInvoice(invoice)(clinicReferenceId, invoiceReferenceId, reason, abortController);
    },
    onSuccess: (result, variables, context) => {
      onSuccess == null ? void 0 : onSuccess(result, variables, context);
    },
    onMutate: async () => {
      return await (onMutate == null ? void 0 : onMutate());
    },
    onError: (error, variables, context) => {
      onError == null ? void 0 : onError(error, variables, context);
    }
  });
  return mutation;
};
export {
  useInvoiceCancellation
};
